// extracted by mini-css-extract-plugin
export var blogImageStyling = "LinkCardComponent-module--blogImageStyling--ba068";
export var contentCard = "LinkCardComponent-module--contentCard--b49db";
export var contentCardFooter = "LinkCardComponent-module--contentCardFooter--82d77";
export var contentStyling = "LinkCardComponent-module--contentStyling--cffd3";
export var divider = "LinkCardComponent-module--divider--a5ca0";
export var doctorsContent = "LinkCardComponent-module--doctorsContent--c6b12";
export var doctorsImg = "LinkCardComponent-module--doctorsImg--1791e";
export var heightAuto = "LinkCardComponent-module--heightAuto--5fd31";
export var imageStyling = "LinkCardComponent-module--imageStyling--1880f";
export var priceStyling = "LinkCardComponent-module--priceStyling--6747f";
export var setHeight = "LinkCardComponent-module--setHeight--f2200";
export var stepContentContainer = "LinkCardComponent-module--stepContentContainer--9a755";
export var stepsOpened = "LinkCardComponent-module--stepsOpened--dfdf2";
export var titleStyling = "LinkCardComponent-module--titleStyling--7e116";
export var toReadMoreContainer = "LinkCardComponent-module--toReadMoreContainer--126bb";
export var withCtaFooter = "LinkCardComponent-module--withCtaFooter--1d20d";